/* eslint-disable */
import React from "react";
import HeAppWrapper from "../../components/HeAppWrapper";
import "./App.scss";
import { useTable, useSortBy } from "react-table";
import dataObj from "./assets/data";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSortDown, faSortUp } from "@fortawesome/free-solid-svg-icons";

const decimalFormatter = new Intl.NumberFormat("en-US", {
    style: "decimal",
    maximumFractionDigits: 0
});

function Table({ columns, data }) {
    // Use the state and functions returned from useTable to build your UI
    const { getTableProps, getTableBodyProps, headerGroups, footerGroups, rows, prepareRow } = useTable(
        {
            columns,
            data
        },
        useSortBy
    );

    // Render the UI for your table
    return (
        <HeAppWrapper className="app-home-wui-mt">
            <table {...getTableProps()}>
                <thead>
                    {headerGroups.map(group => (
                        <tr {...group.getHeaderGroupProps()}>
                            {group.headers.map(column => (
                                <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                                    {column.render("Header")}
                                    <span>{column.isSorted ? (column.isSortedDesc ? <FontAwesomeIcon icon={faSortDown}/> : <FontAwesomeIcon icon={faSortUp}/>) : ""}</span>
                                </th>
                            ))}
                        </tr>
                    ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                    {rows.map((row, i) => {
                        prepareRow(row);
                        return (
                            <tr {...row.getRowProps()}>
                                {row.cells.map(cell => {
                                    return <td {...cell.getCellProps()}>{cell.render("Cell")}</td>;
                                })}
                            </tr>
                        );
                    })}
                </tbody>
                <tfoot>
                    {footerGroups.map(group => {
                        if (group.headers.length === 3) return null;
                        return (
                            <tr {...group.getFooterGroupProps()}>
                                {group.headers.map(column => {
                                    return <td {...column.getFooterProps()}>{column.render("Footer")}</td>;
                                })}
                            </tr>
                        );
                    })}
                </tfoot>
            </table>
        </HeAppWrapper>
    );
}
function getTotal(columnInfo, fieldName) {
    // Only calculate total visits if rows change
    const total = columnInfo.rows.reduce((sum, row) => row.values[fieldName] + sum, 0);
    return String(decimalFormatter.format(total));
}
function App() {
    const columns = React.useMemo(
        () => [
            {
                Header: "County",
                accessor: "county",
                Footer: "Total"
            },
            {
                Header: "Number of homes in 1990",
                // Footer: 'Name',
                columns: [
                    {
                        Header: "High hazard",
                        accessor: "total_high",
                        Cell: ({ cell: { value } }) => String(decimalFormatter.format(value)),
                        Footer: info => getTotal(info, "total_high")
                    },
                    {
                        Header: "Moderate hazard",
                        accessor: "total_moderate",
                        Cell: ({ cell: { value } }) => String(decimalFormatter.format(value)),
                        Footer: info => getTotal(info, "total_moderate")
                    },
                    {
                        Header: "Low hazard",
                        accessor: "total_low",
                        Cell: ({ cell: { value } }) => String(decimalFormatter.format(value)),
                        Footer: info => getTotal(info, "total_low")
                    },
                    {
                        Header: "All homes",
                        accessor: "total_",
                        Cell: ({ cell: { value } }) => String(decimalFormatter.format(value)),
                        Footer: info => getTotal(info, "total_")
                    }
                ]
            },
            {
                Header: "Number of Homes in 2018",
                // Footer: 'Info',
                columns: [
                    {
                        Header: "High hazard",
                        accessor: "new_high",
                        Cell: ({ cell: { value } }) => String(decimalFormatter.format(value)),
                        Footer: info => getTotal(info, "new_high")
                    },
                    {
                        Header: "Moderate hazard",
                        accessor: "new_moderate",
                        Cell: ({ cell: { value } }) => String(decimalFormatter.format(value)),
                        Footer: info => getTotal(info, "new_moderate")
                    },
                    {
                        Header: "Low hazard",
                        accessor: "new_low",
                        Cell: ({ cell: { value } }) => String(decimalFormatter.format(value)),
                        Footer: info => getTotal(info, "new_low")
                    },
                    {
                        Header: "All homes",
                        accessor: "new_",
                        Cell: ({ cell: { value } }) => String(decimalFormatter.format(value)),
                        Footer: info => getTotal(info, "new_")
                    }
                ]
            }
        ],
        []
    );

    return (
        <span className="app-home-wui-mt">
            <Table columns={columns} data={dataObj} />
        </span>
    );
}

export default App;
